import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import makeGeoserverUrlFunction from '../utility/makeGeoserverUrlFunction'

class RasterLayer extends Component {
  static contextTypes = {
    map: PropTypes.object
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  componentWillReceiveProps (props) {
    const { id, paint, layout, before } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && paintDiff[key] && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { id, geoserverId, urlFunction, idToken, layerRendered, paint, time, url, urls=[], minzoom, maxzoom, scheme } = this.props

    const visible = layerRendered
    if (!visible) {
      return null
    }

    const timeIso = time ? new Date(time).toISOString() : ''
    const layerId = geoserverId || id
    const urlString = url || urlFunction()({ id: layerId, idToken, timeIso })

    const urlsString = urls.map(url => url || urlFunction()({ layerId, idToken, timeIso }))

    const source = {
      type: 'raster',
      tiles: urlsString.length > 0 ? urlsString : [urlString],
      tileSize: 512,
      minzoom: minzoom,
      maxzoom: maxzoom,
      scheme: scheme
    }

    return (
      <Fragment key={id}>
        <Source
          key={`${id}Source`}
          id={id}
          tileJsonSource={source}
          />
        <Layer
          key={`${id}Layer`}
          type='raster'
          id={id}
          sourceId={id}
          paint={paint}
        />
      </Fragment>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()

  const mapStateToProps = (state, ownProps) => {
    const { id, authId, datetimeId } = ownProps

    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId || id
      ),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId || id] || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id)
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { id } = ownProps

  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

RasterLayer.propTypes = {
  id: PropTypes.string.isRequired,
  authId: PropTypes.string,
  datetimeId: PropTypes.string,
  urlFunction: PropTypes.func.isRequired,
  paint: PropTypes.object,
  url: PropTypes.string,
  minzoom: PropTypes.number,
  maxzoom: PropTypes.number,
  scheme: PropTypes.string
}

RasterLayer.defaultProps = {
  paint: { 'raster-opacity': 1 },
  urlFunction: makeGeoserverUrlFunction,
  minzoom: 0,
  maxzoom: 22,
  scheme: 'xyz'
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(RasterLayer)



// WEBPACK FOOTER //
// ./src/layers/RasterLayer.js